import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_require_wrkrs_to_join_a_trade_union'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_require_wrkrs_to_join_a_trade_union',
  name: 'Does the facility require workers to join a trade union?',
  description:
    "Union presence in the facility includes the existence of a company union and/or the affiliation of workers from the company to higher level unions (such as sectoral unions).\r\r\n\r\r\nUnion security clauses are used to ensure the membership and funding of unions. These clauses may require workers to join the union, or they may require an employer to hire only union workers, or to deduct union dues from non-union workers. Under international standards, it is acceptable for a country’s laws to allow for union security clauses, or to forbid them. However, in order for these clauses to be compatible with ILO Convention 87, they must be freely negotiated between the union and the employer.\r\r\n\r\r\nConsult applicable legal requirements before answering this question, to determine whether workers may be required to join a union in line with a freely negotiated union security clause.\r\r\n\r\r\nIf applicable legal standards do not permit union security clauses then workers may not be forced to join a union.\r\r\n           \r\r\nIf national law permits union security clauses: Union security clauses are used to ensure the membership and funding of unions. These clauses may require workers to join the union, or may require an employer to hire only union workers, or to deduct union dues from non-union workers.\r\r\n\r\r\nA union security clause is a collective bargaining agreement clause that is used to ensure that workers are excluded from a bargaining unit if they either:\r\r\nDo not support the union.\r\r\nDo not wish to pay union dues associated with union membership.\r\r\nDo not want to pay fees associated with a union representing the workers' bargaining unit.\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, select the answer: Not applicable. No union presence in the facility during assessment period.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'union-na',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'union-na',
    },
    {
      name: 'Not applicable. No union presence in the facility during assessment period.',
      key: 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
      slcpIndex: 3,
      slcpOptionName: 'union-na',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-2--6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12100,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
